import React from 'react';
import styles from './intelligenceInsightsModules.module.css';

const HIDDEN_ACTION_KEYS = new Set(['review_sources', 'review_evidence']);

/**
 * Module-level banner when new VDR / IRL / Observations arrived after the analysis version.
 */
const InsightsNewEvidenceBanner = ({ banner, onAction }) => {
    if (!banner) return null;

    const visibleActions = (banner.actions || []).filter(
        action => action?.key && !HIDDEN_ACTION_KEYS.has(action.key),
    );

    return (
        <div className={styles.newEvidenceBanner} role="status">
            <div className={styles.newEvidenceBannerTop}>
                <span className={styles.newEvidenceDot} aria-hidden />
                <p className={styles.newEvidenceTitle}>{banner.title || 'New evidence available'}</p>
            </div>
            {banner.message ? <p className={styles.newEvidenceMessage}>{banner.message}</p> : null}
            {banner.breakdown ? <p className={styles.newEvidenceBreakdown}>{banner.breakdown}</p> : null}
            {banner.affected ? <p className={styles.newEvidenceAffected}>{banner.affected}</p> : null}
            {visibleActions.length ? (
                <div className={styles.newEvidenceActions}>
                    {visibleActions.map(action => (
                        <button
                            key={action.key}
                            type="button"
                            className={styles.newEvidenceActionBtn}
                            onClick={() => onAction?.(action.key)}>
                            {action.label}
                        </button>
                    ))}
                </div>
            ) : null}
        </div>
    );
};

export default InsightsNewEvidenceBanner;
